/* FAQ */

document.querySelectorAll('.faq-question').forEach((question) => {
  question.addEventListener('click', () => {
    const isActive = question.classList.contains('active');
    
    // 全FAQを閉じる
    document.querySelectorAll('.faq-question').forEach(q => q.classList.remove('active'));
    document.querySelectorAll('.faq-answer').forEach(a => a.classList.remove('active'));
    
    // クリックした項目が閉じていたら開く
    if (!isActive) {
      question.classList.add('active');
      question.nextElementSibling.classList.add('active');
    }
  });
});


/*　商品ページ　*/
//ページ内リンクでid設置
 document.addEventListener("DOMContentLoaded", function() {
    const accordion = document.querySelector('.collapsible-content');
    if (accordion) {
      accordion.setAttribute('id', 'accordion-description');
    }
  });